var image_upload_default = {
  "container": "hAmWq",
  "disabled": "CRZaR",
  "imageInput": "pGFb5",
  "overlay": "_9JN8z",
  "text": "RAzVi",
  "shown": "EZoo1",
  "hide": "AC9hT",
  "spinner": "xvnpH",
  "spin": "cWI2k"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
